import { type ErrorInfo, useCallback } from 'react';

export const useAppConfiguration = () => {
  const onErrorHandler = useCallback((error: Error, { componentStack }: ErrorInfo): void => {
    console.error(error, componentStack);
  }, []);

  return {
    onErrorHandler,
  };
};
